import React from "react";
import PropTypes from "prop-types";
import { StyledText } from "./Text.styles";

const variantElementMap = {
  pageHeading: "h1",
  sectionHeading: "h2",
  cardHeading: "h3",
  body: "p",
  bodyMedium: "p",
  label: "span",
  caption: "span",
};

export const Text = ({
  variant = "body",
  as,
  color,
  weight,
  size,
  font,
  align,
  truncate,
  mb,
  children,
  ...rest
}) => {
  const defaultElement = variantElementMap[variant] || "p";

  return (
    <StyledText
      as={as || defaultElement}
      $variant={variant}
      $color={color}
      $weight={weight}
      $size={size}
      $font={font}
      $align={align}
      $truncate={truncate}
      $mb={mb}
      {...rest}
    >
      {children}
    </StyledText>
  );
};

Text.propTypes = {
  variant: PropTypes.oneOf([
    "pageHeading",
    "sectionHeading",
    "cardHeading",
    "body",
    "bodyMedium",
    "label",
    "caption",
  ]),
  as: PropTypes.string,
  color: PropTypes.string,
  weight: PropTypes.string,
  size: PropTypes.string,
  font: PropTypes.oneOf(["geist", "aeonik"]),
  align: PropTypes.string,
  truncate: PropTypes.bool,
  mb: PropTypes.string,
  children: PropTypes.node,
};

export const PageHeading = (props) => <Text variant="pageHeading" {...props} />;
export const SectionHeading = (props) => (
  <Text variant="sectionHeading" {...props} />
);
export const CardHeading = (props) => <Text variant="cardHeading" {...props} />;
export const Body = (props) => <Text variant="body" {...props} />;
export const BodyMedium = (props) => <Text variant="bodyMedium" {...props} />;
export const Label = (props) => <Text variant="label" {...props} />;
export const Caption = (props) => <Text variant="caption" {...props} />;
